<template>
  <page>
    <template slot="title">Консалтинг</template>
    <template slot="section">
      <columns>
        <column size="10">
          <p>Сложное для понимания и быстро меняющееся законодательство в области электроэнергетики, потребность точно планировать затраты на энергоресурсы и важность экономии для обеспечения конкурентоспособности производства приводят к необходимости принятия квалифицированных управленческих решений в части энергетики.</p>
          <p>Наша компания обеспечит Вас необходимой актуальной информацией для грамотного управления энергетикой предприятия. Мы предлагаем консалтинг всех видов в зависимости от поставленных Вами задач, включая:</p>
          <ul>
            <li>прогнозирование цен на электроэнергию и мощность;</li>
            <li>­составление бюджета предприятия в части энергоресурсов;</li>
            <li>­анализ действующей схемы энергоснабжения;</li>
            <li>­проверку счетов-фактур и расчета стоимости электроэнергии другими энергосбытовыми компаниями;</li>
            <li>­разработку плана мероприятий по оптимизации затрат на энергоресурсы;</li>
            <li>­экспресс - анализ договорных конструкций;</li>
            <li>­юридическое сопровождение;</li>
            <li>­экспертную оценку всех видов проектов в области энергетики.</li>
          </ul>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-13.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>



// WEBPACK FOOTER //
// Consulting.vue?a5d4b8b0